<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';

const router = useRouter();
const { accountId } = useAccount();
const apps = ref([]);
const loading = ref(true);

onMounted(async () => {
  try {
    const { data } = await window.axios.get(
      `/api/v1/accounts/${accountId.value}/powerapps`
    );
    apps.value = data;
  } catch {
    apps.value = [];
  }
  loading.value = false;
});

const open = slug =>
  router.push({
    name: 'powerapp',
    params: { accountId: accountId.value, slug },
  });
</script>

<template>
  <div class="flex flex-col w-full h-full p-8 overflow-auto bg-n-background">
    <h1 class="mb-6 text-xl font-semibold text-n-slate-12">
      {{ $t('POWER_APPS.HEADING') }}
    </h1>

    <div v-if="loading" class="text-sm text-n-slate-11">
      {{ $t('POWER_APPS.LOADING') }}
    </div>

    <div
      v-else-if="apps.length"
      class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3"
    >
      <button
        v-for="a in apps"
        :key="a.slug"
        class="p-5 text-left transition-all duration-150 border rounded-pz border-n-weak bg-n-card shadow-pz hover:border-n-brand hover:shadow-pz-hover hover:-translate-y-px"
        @click="open(a.slug)"
      >
        <div class="text-base font-medium text-n-slate-12">{{ a.name }}</div>
        <div class="mt-1 text-sm text-n-slate-11">{{ a.slug }}</div>
      </button>
    </div>

    <div
      v-else
      class="grid flex-1 max-w-md mx-auto text-center place-content-center"
    >
      <div class="text-base font-medium text-n-slate-12">
        {{ $t('POWER_APPS.EMPTY_TITLE') }}
      </div>
      <p class="mt-2 text-sm leading-relaxed text-n-slate-11">
        {{ $t('POWER_APPS.EMPTY_BODY') }}
      </p>
    </div>
  </div>
</template>
